import AssessmentServiceApi from "../../services/assessment-api";

// const quack = () => ({
//   // type: Types.QUACK,

// });

const getAssessmentResultByAssessmentAttemptId = (
  assessmentAttemptId,
  languageCode
) => {
  return function () {
    return AssessmentServiceApi.getAssessmentResultByAssessmentAttemptId(
      assessmentAttemptId,
      languageCode
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("UserAnswer Error", error));
  };
};
const getPlans = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getPlans(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("UserAnswer Error", error));
  };
};

const getAbTest = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.getAbTest(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("AB TEST Error", error));
  };
};

export { getAssessmentResultByAssessmentAttemptId, getPlans, getAbTest };
